export default "__VITE_ASSET__B7G8TbDH__"